import styles from './organization-hero.module.scss';

type OrganizationHeroProps = {
  name: string;
  heroImageUrl?: string | null;
};

export const OrganizationHero = ({
  name,
  heroImageUrl
}: OrganizationHeroProps) => (
  <section className={styles.hero}>
    {heroImageUrl && (
      <img
        src={heroImageUrl}
        alt={`Volunteers supporting ${name}`}
        className={styles.heroImage}
      />
    )}
  </section>
);
